/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useContext, useCallback, useEffect, useMemo
} from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useUpdateSubmissionServices, useCheckSubmissionVMDirty, validationUtil } from 'premier-capability-hooks';
import { PremierConstants } from 'premier-constant-service';
import { EntityUtil } from '@xengage/gw-portals-util-js';
import styles from "../../SpecialtyPersonalStyles.module.scss"
import RiskAssistDwellingsComponent from '../../components/RiskAssistDwellings/RiskAssistDwellings/RiskAssistDwellingsComponent';
import metadata from './RiskAssistDwellingsPage.metadata.json5'


function RiskAssistDwellingsPage(props) {
    
    const {
       wizardData: submissionVM,
       updateWizardData,
       viewModelService
    } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const {
        onValidate,
        initialValidation,
        isComponentValid
    } = useValidation('RiskAssistDwellingsPage');
    const { updateSubmission } = useUpdateSubmissionServices();
    const { lineName } = PremierConstants;


    const onNext = useCallback(async () => {
        const productCode = _.get(submissionVM.value, 'baseData.productCode');
        // eslint-disable-next-line security/detect-object-injection
        const lobLineName = productCode ? lineName[productCode] : "";
        const response = await updateSubmission(
            lobLineName,
            "RiskAssistDwellingsPage",
            submissionVM
        );

        submissionVM.value = response;

        return submissionVM;

        },[lineName, submissionVM, updateSubmission]);

    const onSave = useCallback(async () => {
      const subVMCopy = _.clone(submissionVM)
      const productCode = _.get(subVMCopy.value, 'baseData.productCode');

      validationUtil.unSetIsValidationReqFlag(subVMCopy.lobData.perLine.coverables.riskAssistDwellingsCoverable.riskAssistDwellings.value, ' ')

      const lobLineName = productCode ? lineName[productCode] : '';
      await updateSubmission(lobLineName, 'RiskAssistDwellingsPage', subVMCopy);
                      
      return submissionVM;
    },[lineName, updateSubmission, submissionVM]);

    const addRiskAssistDwellings = useCallback(async () => {
        const riskAssistDwellingsObj = {
            tempID: EntityUtil.nextId(),
            propertyDetails: {
                isValidationReq: true
            },
            construction: {
                isValidationReq: true
            },
            utilities: {
                isValidationReq: true
            },
            oilTank: {
                isValidationReq: true
            },
            solidFuelHeating: {
                isValidationReq: true
            },
            rentalsTenants: {
                isValidationReq: true
            }
        };

        // eslint-disable-next-line no-unsafe-optional-chaining
        const { _xCenter, _dtoName } = submissionVM?.lobData?.perLine?.coverables?.riskAssistDwellingsCoverable?.riskAssistDwellings;

        const riskAssistDwellingsVM = viewModelService.create(riskAssistDwellingsObj, _xCenter, _dtoName);

        submissionVM.lobData.perLine.coverables.riskAssistDwellingsCoverable.riskAssistDwellings.value = submissionVM.lobData.perLine.coverables.riskAssistDwellingsCoverable.riskAssistDwellings.value || []

        submissionVM.lobData.perLine.coverables.riskAssistDwellingsCoverable.riskAssistDwellings.pushElement(
            riskAssistDwellingsVM
        )

        updateWizardData(submissionVM);

    }, [submissionVM, viewModelService, updateWizardData])

    const riskAssistDwellingsOverrides = useMemo(() => {
        const riskAssistDwellingsList = _.get(submissionVM, 'lobData.perLine.coverables.riskAssistDwellingsCoverable.riskAssistDwellings', []);
        let overrides = [];

        if (!_.isEmpty(riskAssistDwellingsList)) {
            overrides = riskAssistDwellingsList?.children.map((riskAssistDwelling, index) => ({
                [`riskAssistDwellingsComponent${index}`]: {
                    overrideProps: {
                        "@field": {
                            // apply to all fields
                            showRequired: true,
                            labelPosition: "left",
                        },
                    },
                    submissionVM,
                    updateWizardData,
                    pathUpdated: `lobData.perLine.coverables.riskAssistDwellingsCoverable.riskAssistDwellings.children[${index}]`,
                    riskAssistDwellingsVM : riskAssistDwelling,
                    index,
                    viewModelService
                }
            }));

            
        }

        return Object.assign({}, ...overrides);

    }, [updateWizardData, viewModelService, submissionVM]);

    const overrideProps = {
        "@field": {
            showRequired: true,
            labelPosition: breakpoint === "desktop" ? "left" : "top"
        },
        ...riskAssistDwellingsOverrides,
        
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            addRiskAssistDwellings
        },
        resolveComponentMap: {
            riskAssistDwellingsComponent: RiskAssistDwellingsComponent,
            // riskInformation: RiskInformationComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        [metadata.pageContent, submissionVM, overrideProps]
    );


    const isDisableNext = () => !submissionVM.lobData.perLine.coverables.riskAssistDwellingsCoverable.riskAssistDwellings.aspects.subtreeValid

    return (
        <WizardPage 
            onNext={onNext} 
            onSave={onSave} 
            skipWhen={() => initialValidation} 
            disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

RiskAssistDwellingsPage.propTypes = wizardProps;
export default withViewModelService(RiskAssistDwellingsPage);
